import styled from "styled-components";

export const TabWrapper = styled.div`
  display: flex;
  justify-content: ${({ tabPosition }) =>
    tabPosition === "center" ? "center" : "unset"};
  flex-wrap: nowrap;
  white-space: nowrap;
  column-gap: 12px;
  height: 28px;
  width: auto;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  padding-right: ${(props) => props?.paddingRight ?? "20px"};

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: 720px) {
    height: 32px;
  }
`;

export const Tab = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: ${(props) =>
    props?.isActive ? props?.activeColor : props?.inactiveColor};
  font-family: Gilroy;
  font-size: 16px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.091px;
  padding-top: 4px;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */

  @media screen and (max-width: 400px) {
    font-size: 14px;
  }

  @media only screen and (min-width: 769px) {
    font-size: 22px;
    line-height: 24px;
  }
`;

export const BorderLine = styled.div`
  height: 3px;
  width: 100%;
  border-radius: 8px;
  background-color: #00bcf1;

  @media screen and (min-width: 720px) {
    align-self: center;
  }
`;

export const Chips = styled.div`
  border-radius: 80px;
  padding: 8px 10px;
  border: ${({ isActive }) =>
    isActive ? "1px solid #FFFFFF" : "1px solid #DDE2E8"};
  background-color: ${({ isActive }) => (isActive ? "#1F2D3D" : "#FFFFFF")};
  color: ${({ isActive }) => (isActive ? "#FFFFFF" : "#6A7481")};
  display: flex;
  align-items: center;
  cursor: pointer;

  p {
    margin: 0 !important;
    padding: 0 !important;
  }
`;
